import clsx from 'clsx';
import { TrackedHeader } from '@objectiv/tracker-react';
import { USPBar } from './USPBar';
import { NavigationBar } from './NavigationBar';

import * as styles from './Header.module.css';

import type { HeaderCta, UspBarContent } from '~models/contentful';

type HeaderProps = {
  uspBarContent?: UspBarContent;
  headerCta?: HeaderCta;
};

export const Header: React.FC<HeaderProps> = ({ uspBarContent, headerCta }) => (
  <TrackedHeader
    objectiv={{ id: 'header' }}
    className={clsx(styles.header, uspBarContent && styles.withUspBar)}
    style={{ '--USPBarHeight': uspBarContent ? '32px' : '0px' } as React.CSSProperties}
    id='insify-header'
  >
    {uspBarContent && <USPBar content={uspBarContent} />}
    <NavigationBar headerCta={headerCta} />
  </TrackedHeader>
);
